import Vue from 'vue'
import VueRouter from 'vue-router'

import { notification } from 'ant-design-vue'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import Forbidder from '@/views/403'
import NotFound from '@/views/404'
import ServerErr from '@/views/500'
import RouteView from '@/layouts/RouteView'

// 引入vuex
import store from '@/store'

import routerTxt from '../i18n/lang/router/router'
import { mapState } from 'vuex'

// 解决相同路径跳转报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) { return originalPush.call(this, location, onResolve, onReject) }
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/user',
    name: 'user',
    hideInMenu: true,
    component: () =>
      import(/* webpackChunkName: 'userLayout' */ '@/layouts/UserLayout'),
    children: [
      {
        path: '/user',
        redirect: '/user/login'
      },
      {
        path: '/user/login',
        name: 'userLogin',
        component: () =>
          import(/* webpackChunkName: 'userLogin' */ '@/views/user/login')
      },
      {
        path: '/user/register',
        name: 'userRegister',
        component: () =>
          import(/* webpackChunkName: 'userRegister' */ '@/views/user/register')
      },
      {
        path: '/user/change-password',
        name: 'userChangePassword',
        component: () =>
          import(
            /* webpackChunkName: 'userChangePassword' */ '@/views/user/changePassword'
          )
      }
    ]
  },
  {
    path: '/',
    // meta: { icon: '', title: '智能门禁管理系统', authority: '', bread: true },
    component: () =>
      import(/* webpackChunkName: 'basicLayout' */ '@/layouts/BasicLayout'),
    children: [
      {
        path: '',
        redirect: '/home'
      },
      {
        // homeIndex
        path: '/home',
        name: 'homeIndex',
        hideInMenu: false,
        meta: {
          icon: 'home',
          title: 'router.home',
          authority: 'homeIndex',
          bread: true
        },
        component: () =>
          import(/* webpackChunkName: 'homeIndex' */ '@/views/home/index.vue')
      },
      {
        // userCenter
        path: '/user-center',
        name: 'userCenter',
        hideInMenu: true,
        meta: {
          icon: 'user',
          title: 'router.userCenter',
          authority: 'userCenter',
          bread: false
        },
        component: RouteView,
        children: [
          {
            path: '/user-center',
            redirect: '/user-center/index'
          },
          {
            path: '/user-center/index',
            name: 'userCenterIndex',
            meta: {
              icon: '',
              title: 'router.userCenter',
              authority: 'userCenter',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'userCenterIndex' */ '@/views/user-center/index.vue'
              )
          }
        ]
      },
      {
        // orgManaIndex
        path: '/org-mana',
        name: 'orgManaIndex',
        hideInMenu: false,
        meta: {
          icon: 'apartment',
          title: 'router.orgMana',
          authority: 'orgManaIndex',
          bread: true
        },
        component: () =>
          import(
            /* webpackChunkName: 'orgManaIndex' */ '@/views/org-mana/index.vue'
          )
      },
      {
        // personalMana
        path: '/personal-mana',
        name: 'personalMana',
        hideInMenu: false,
        hideChildrenInMenu: true,
        meta: {
          icon: 'user',
          title: 'router.personalMana',
          authority: 'personalMana',
          bread: true
        },
        component: RouteView,
        children: [
          {
            path: '/personal-mana',
            redirect: '/personal-mana/index'
          },
          {
            path: '/personal-mana/index',
            name: 'personalManaIndex',
            meta: {
              icon: '',
              title: 'router.personalMana',
              authority: 'personalMana',
              bread: false,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'personalManaIndex' */ '@/views/personal-mana/index.vue'
              )
          },
          {
            path: '/personal-mana/new',
            name: 'personalManaNew',
            meta: {
              icon: '',
              title: 'router.newPersonal',
              authority: 'personalMana',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'personalManaNew' */ '@/views/personal-mana/new.vue'
              )
          },
          {
            path: '/personal-mana/edit',
            name: 'personalManaEdit',
            meta: {
              icon: '',
              title: 'router.editPersonal',
              authority: 'personalMana',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'personalManaEdit' */ '@/views/personal-mana/edit.vue'
              )
          },
          {
            path: '/personal-mana/auth',
            name: 'personalManaAuth',
            meta: {
              icon: '',
              title: 'router.editAuth',
              authority: 'personalMana',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'personalManaAuth' */ '@/views/personal-mana/auth.vue'
              )
          },
          {
            path: '/personal-mana/auth-batch',
            name: 'personalManaAuthBatch',
            meta: {
              icon: '',
              title: 'router.authBatch',
              authority: 'personalMana',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'personalManaAuthBatch' */ '@/views/personal-mana/auth-batch.vue'
              )
          }
        ]
      },
      {
        // devicesMana
        path: '/devices-mana',
        name: 'devicesMana',
        hideInMenu: false,
        hideChildrenInMenu: true,
        meta: {
          icon: 'setting',
          title: 'router.devicesMana',
          authority: 'devicesManaIndex',
          bread: true
        },
        component: RouteView,
        children: [
          {
            path: '/devices-mana',
            redirect: '/devices-mana/index'
          },
          {
            path: '/devices-mana/index',
            name: 'devicesManaIndex',
            meta: {
              icon: '',
              title: 'router.devicesMana',
              authority: 'devicesManaIndex',
              bread: false,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'devicesManaIndex' */ '@/views/devices-mana/index.vue'
              )
          },
          {
            path: '/devices-mana/active-time',
            name: 'devicesManaActiveTime',
            meta: {
              icon: '',
              title: 'router.deviceActiveTime',
              authority: 'devicesManaActiveTime',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'devicesManaActiveTime' */ '@/views/devices-mana/active-time.vue'
              )
          },
          {
            path: '/devices-mana/config',
            name: 'devicesManaConfig',
            meta: {
              icon: '',
              title: 'router.deviceConfig',
              authority: 'devicesManaConfig',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'devicesManaConfig' */ '@/views/devices-mana/config.vue'
              )
          }
        ]
      },
      {
        // timeConfigIndex
        path: '/time-config',
        name: 'timeConfigIndex',
        hideInMenu: false,
        meta: {
          icon: 'clock-circle',
          title: 'router.timeConfig',
          authority: 'timeConfig',
          bread: true
        },
        component: () =>
          import(
            /* webpackChunkName: 'timeConfigIndex' */ '@/views/time-config/index.vue'
          )
      },
      {
        // visitorMana
        path: '/financial-mana',
        name: 'visitorMana',
        meta: {
          icon: 'property-safety',
          title: 'router.financial',
          authority: 'financial',
          bread: false
        },
        component: RouteView,
        children: [
          {
            path: '/financial-mana/recharge',
            name: 'rechargeIndex',
            meta: {
              icon: '',
              title: 'router.recharge',
              authority: 'recharge',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'reservedVisitor' */ '@/views/financial-mana/recharge/RechargeForm.vue'
              )
          },
          {
            path: '/financial-mana/orders',
            name: 'ordersIndex',
            meta: {
              icon: '',
              title: 'router.orders',
              authority: 'orders',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'visitorRecord' */ '@/views/financial-mana/orders/index.vue'
              )
          },
          {
            path: '/financial-mana/invoices',
            name: 'invoicesIndex',
            meta: {
              icon: '',
              title: 'router.invoices',
              authority: 'invoices',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'visitorPath' */ '@/views/financial-mana/invoices/index.vue'
              )
          },
          {
            path: '/financial-mana/invoice-apply',
            name: 'applyInvoice',
            meta: {
              icon: '',
              title: 'router.invoicesApply',
              authority: 'invoicesApply',
              bread: false,
              hasRouteView: true,
              invisible: true,
            },
            hidden: true ,// 在菜单栏隐藏该页面
            component: () =>
              import(
                /* webpackChunkName: 'visitorPath' */ '@/views/financial-mana/invoices/components/ApplyInvoice/index.vue'
                )
          },
          {
            path: '/financial-mana/service-log',
            name: 'serviceLog',
            meta: {
              icon: '',
              title: 'router.serviceLog',
              authority: 'serviceLog',
              bread: false,
              hasRouteView: true,
              invisible: true,
            },
            component: () =>
              import('@/views/financial-mana/serviceLog/index.vue' )
          }
        ]
      },
      {
        // visitorMana
        path: '/visitor-mana',
        name: 'visitorMana',
        meta: {
          icon: 'team',
          title: 'router.visitorMana',
          authority: 'visitorMana',
          bread: false
        },
        component: RouteView,
        children: [
          {
            path: '/visitor-mana/reserved',
            name: 'reservedVisitor',
            meta: {
              icon: '',
              title: 'router.reservedVisitor',
              authority: 'reservedVisitor',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'reservedVisitor' */ '@/views/visitor-mana/reserved.vue'
              )
          },
          {
            path: '/visitor-mana/record',
            name: 'visitorRecord',
            meta: {
              icon: '',
              title: 'router.visitorRecord',
              authority: 'visitorRecord',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'visitorRecord' */ '@/views/visitor-mana/record.vue'
              )
          },
          {
            path: '/visitor-mana/path',
            name: 'visitorPath',
            meta: {
              icon: '',
              title: 'router.visitorPath',
              authority: 'visitorPath',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'visitorPath' */ '@/views/visitor-mana/path.vue'
              )
          }
        ]
      },
      {
        // blackListManaIndex
        path: '/black-list-mana',
        name: 'blackListManaIndex',
        hideInMenu: false,
        meta: {
          icon: 'stop',
          title: 'router.blackList',
          authority: 'blackListManaIndex',
          bread: true
        },
        component: () =>
          import(
            /* webpackChunkName: 'blackListManaIndex' */ '@/views/black-list-mana/index.vue'
          )
      },
      {
        // identificationRecordIndex
        path: '/identification-record',
        name: 'identificationRecordIndex',
        hideInMenu: false,
        meta: {
          icon: 'eye',
          title: 'router.identificationRecord',
          authority: 'identificationRecordIndex',
          bread: true
        },
        component: () =>
          import(
            /* webpackChunkName: 'identificationRecordIndex' */ '@/views/identification-record/index.vue'
          )
      },
      {
        // warningManaIndex
        path: '/warning-mana',
        name: 'warningManaIndex',
        hideInMenu: false,
        meta: {
          icon: 'bell',
          title: 'router.warningMana',
          authority: 'warningManaIndex',
          bread: true
        },
        component: () =>
          import(
            /* webpackChunkName: 'warningManaIndex' */ '@/views/warning-mana/index.vue'
          )
      },
      {
        // alarmManaIndex
        path: '/alarm-mana',
        name: 'alarmManaIndex',
        hideInMenu: false,
        meta: {
          icon: 'alert',
          title: 'router.alarmMana',
          authority: 'alarmManaIndex',
          bread: true
        },
        component: () =>
          import(
            /* webpackChunkName: 'alarmManaIndex' */ '@/views/alarm-mana/index.vue'
          )
      },
      {
        // logMana
        path: '/log-mana',
        name: 'logMana',
        hideInMenu: false,
        meta: {
          icon: 'profile',
          title: 'router.logMana',
          authority: 'logMana',
          bread: false
        },
        component: RouteView,
        children: [
          {
            path: '/log-mana/operation',
            name: 'operationLog',
            meta: {
              icon: '',
              title: 'router.operationLog',
              authority: 'operationLog',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'operationLog' */ '@/views/log-mana/operation.vue'
              )
          },
          {
            path: '/log-mana/work',
            name: 'workLog',
            meta: {
              icon: '',
              title: 'router.workLog',
              authority: 'workLog',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'workLog' */ '@/views/log-mana/work.vue'
              )
          },
          {
            path: '/log-mana/sync',
            name: 'syncLog',
            meta: {
              icon: '',
              title: 'router.syncLog',
              authority: 'syncLog',
              bread: true,
              hasRouteView: true
            },
            component: () =>
              import(
                /* webpackChunkName: 'syncLog' */ '@/views/log-mana/sync.vue'
              )
          }
        ]
      },
      {
        // repeatDataIndex
        path: '/repeat-data',
        name: 'repeatDataIndex',
        hideInMenu: true,
        meta: {
          icon: 'profile',
          title: 'router.repeatData',
          authority: 'repeatDataIndex',
          bread: true
        },
        component: () =>
          import(
            /* webpackChunkName: 'repeatDataIndex' */ '@/views/repeat-data/index.vue'
          )
      }
    ]
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    hideInMenu: true,
    component: () =>
      import(/* webpackChunkName: 'dashboard' */ '@/views/dashboard/index.vue')
  },
  {
    path: '/403',
    name: '403',
    hideInMenu: true,
    component: Forbidder
  },
  {
    path: '/500',
    name: '500',
    hideInMenu: true,
    component: ServerErr
  },
  {
    path: '/404',
    name: '404',
    hideInMenu: true,
    component: NotFound
  },
  {
    path: '/*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // console.log('router.beforeEach to: ', to);
  // console.log('router.beforeEach from: ', from);

  const lang = store.state.lang.replace('_', '')
  // 限制可打开的标签页个数，以确保性能消耗不会太大
  const openPages = store.state.multTabStore.keepAliveInclude.filter(
    page => page !== 'RouteView'
  )
  if (openPages.length > 9 && !openPages.includes(to.name)) {
    notification.warning({
      message: routerTxt[lang].maxPageTabWarn,
      description: routerTxt[lang].maxPageTabWarnDesc
    })
    return
  }
  // 跳转页面时显示进度条
  if (to.path !== from.path) {
    NProgress.start()
  }

  // 当进入功能页面时，若未登录，则跳转登录页面
  if (
    to.path !== '/user/login' &&
    to.path !== '/user/register' &&
    to.path !== '/user/change-password' &&
    to.path !== '/403' &&
    to.path !== '/404' &&
    to.path !== '/500' &&
    !store.state.userInfo
  ) {
    next({
      path: '/user/login'
    })
  }

  // 若登录，获取枚举、机构、重复信息等系统数据
  if (store.state.userInfo) {
    Promise.all([getEnumsData(), getOrgTreeSourceData(), getSysRepeatData()])
      .then(resArr => {
        // console.log('--Promise.all--', resArr)
        // 处理重复数据的提示
        if (resArr[2] && to.path !== '/dashboard') {
          let count = resArr[2].reduce((acc, current) => {
            return acc + current.data.size
          }, 0)

          if (count) {
            notification.warning({
              message: routerTxt[lang].sysRepeatDataWarn(count),
              description: routerTxt[lang].sysRepeatDataWarnDesc
            })
          }
        }
        next()
      })
      .catch(error => {
        next()
      })
  } else {
    next()
  }
})

router.afterEach(() => {
  // window.scrollTo(0, 0);
  NProgress.done()
})

// 若store里无枚举值(enumsData)，则请求
function getEnumsData() {
  if (!Object.keys(store.state.enumsStore.enumsData).length) {
    return store.dispatch('getEnumsData')
  }
  return Promise.resolve()
}
// 若store里不存在组织机构树数据(orgTreeSourceData)，则请求
function getOrgTreeSourceData() {
  if (!store.state.orgStore.orgTreeSourceData.length) {
    return store.dispatch('getOrgTreeSourceData')
  }
  return Promise.resolve()
}

// 若store里不存在系统重复数据数量(sysRepeatDataNumber)，则请求
function getSysRepeatData() {
  if (store.state.sysRepeatDataStore.sysRepeatDataNum === undefined) {
    return store.dispatch('getSysRepeatData')
  }
  return Promise.resolve()
}

export default router
